
import React from "react";
import "./LibraryVideoSection.css";
import { vcsList } from "../../data/vcData";

const LibraryVideoSection = () => {
  // Current Vice Chancellor
  const currentVCData = vcsList.find(
    (vc) => vc.id === 9
  ) || vcsList[vcsList.length - 1];

  const viceChancellor = {
    name: currentVCData.name,
    image: "/person/vicechancellor1.JPG",
    title: "Hon'ble Vice Chancellor",
    institution: "Rayalaseema University, Kurnool",
  };

  const headOfLibrary = {
    name: "S. Nagabhushanam",
    image: "/campuslife/library/Library_incharge.JPG",
    title: "In-charge of Central Library",
    institution: "Rayalaseema University, Kurnool",
  };

  return (
    <section className="library-admin-section">
      <div className="library-admin-container">

        {/* Vice Chancellor Hero Section */}
        <div className="vc-hero-section">
          <div className="vc-hero-image">
            <img
              src={viceChancellor.image}
              alt={viceChancellor.name}
            />
          </div>

          <div className="vc-hero-content">
            <span className="vc-hero-label">
              University Leadership
            </span>

            <h2>{viceChancellor.title}</h2>

            <h1>{viceChancellor.name}</h1>

            <p className="vc-hero-institution">
              {viceChancellor.institution}
            </p>

            <div className="vc-hero-divider"></div>


            <p className="vc-hero-message">
              The Central Library of Rayalaseema University plays a vital
              role in promoting knowledge, academic excellence, and
              research. It supports students, faculty members, and research
              scholars by providing access to learning resources that
              encourage reading, independent study, innovation, and
              intellectual growth. We strive to foster a vibrant academic
              environment where knowledge is shared, ideas are developed,
              and lifelong learning is encouraged.
            </p>

          </div>
        </div>

        {/* Central Library */}
        <div className="library-section-heading">
          <h2 className="library-admin-title">
            Central Library
          </h2>
          <p>
            A gateway to knowledge, learning, and research.
          </p>
        </div>

        {/* Library In-charge Profile */}
        <div className="library-admin-grid">
          <div className="library-admin-card librarian">
            <div className="admin-image-wrapper">
              <img
                src={headOfLibrary.image}
                alt={headOfLibrary.name}
              />
            </div>

            <div className="admin-details">
              <h4 className="admin-role">
                {headOfLibrary.title}
              </h4>

              <h3 className="admin-name">
                {headOfLibrary.name}
              </h3>

              <p className="admin-org">
                {headOfLibrary.institution}
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default LibraryVideoSection;
